import React, { useEffect } from 'react';
import cN from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import parse from 'html-react-parser';
import { RootState, store } from '@Redux/detail/store';
import { I_EachTrip } from '@Redux/detail/Itineraries/interfaces';
import styles from './styles.module.scss';

const ItinerarySelfGuided = () => {
    const { EachTripList } = useSelector((store: RootState) => store.itinerariesReducer);
    return (
        <>
            {EachTripList.map((item: I_EachTrip) => (
                <div className={cN(styles.selfGuided)} key={item.Number}>
                    <div className={styles['selfGuided_head']}>第{item.Number}種</div>
                    <div className={styles['selfGuided_body']}>
                        <div className={styles['selfGuided_info']}>
                            <div className={styles['selfGuided_title']}>餐食</div>
                            <div
                                className={styles['selfGuided_content']}
                                dangerouslySetInnerHTML={{ __html: item.Meals }}
                            />
                        </div>
                        <div className={styles['selfGuided_info']}>
                            <div className={styles['selfGuided_title']}>飯店</div>
                            {/* <div className={styles['selfGuided_content']}>{item.Hostels}</div> */}
                            <div
                                className={styles['selfGuided_content']}
                                dangerouslySetInnerHTML={{ __html: item.Hostels }}
                            />
                        </div>
                        <div
                            className={styles['selfGuided_intro']}
                            dangerouslySetInnerHTML={{ __html: item.FreeInfo }}
                        />
                    </div>
                </div>
            ))}
        </>
    );
};

export default ItinerarySelfGuided;
